module.exports = __webpack_public_path__ + "img/moon.e788f6a1.png";